module.exports = __webpack_public_path__ + "img/全球时尚数据一网打尽.25a8686a.gif";